// 1. IMPORTS
import React, { useEffect, useState } from "react";
import PaymentMethodConfigPanelATMBank from "./PaymentMethodConfigPanelATMBank";
import PaymentMethodConfigPanelMomo from "./PaymentMethodConfigPanelMomo";
import PaymentMethodConfigPanelGtelpay from "./PaymentMethodConfigPanelGtelpay";
import PaymentMethodConfigPanelVnpay from "./PaymentMethodConfigPanelVnpay";
import PaymentMethodConfigPanelZalopay from "./PaymentMethodConfigPanelZalopay";
import PaymentMethodConfigPanelViettelPay from "./PaymentMethodConfigPanelViettelPay";
import PaymentMethodTypeServiceAPI from "services/PaymentMethodTypeServiceAPI";
import { PAYMENT_METHOD_TYPE } from "constants/paymentMethod";

// 2. COMPONENT & STATES
function PaymentMethod() {
  const [listPaymentMethodType, setListPaymentMethodType] = useState([]);
  const [paymentMethodType, setPaymentMethodType] = useState(null);

  // 4. API CALLS & EVENT HANDLERS
  const getPaymentMethodType = async () => {
    try {
      const data = await PaymentMethodTypeServiceAPI.getListPaymentMethodType({ skip: 0, limit: 100 });
      setListPaymentMethodType(data?.data || []);
    } catch (error) {
      setListPaymentMethodType([]);
    }
  };

  const handleBack = () => setPaymentMethodType(null);

  // 5. SIDE EFFECTS
  useEffect(() => {
    getPaymentMethodType();
  }, []);

  // 6. PANEL CONFIGURATION
  const configPanels = {
    [PAYMENT_METHOD_TYPE.ATM_BANK]: PaymentMethodConfigPanelATMBank,
    [PAYMENT_METHOD_TYPE.MOMO]: PaymentMethodConfigPanelMomo,
    [PAYMENT_METHOD_TYPE.GTELPAY]: PaymentMethodConfigPanelGtelpay,
    [PAYMENT_METHOD_TYPE.VNPAY]: PaymentMethodConfigPanelVnpay,
    [PAYMENT_METHOD_TYPE.ZALOPAY]: PaymentMethodConfigPanelZalopay,
    [PAYMENT_METHOD_TYPE.VIETTEL_PAY]: PaymentMethodConfigPanelViettelPay,
  };
  const ConfigPanel = configPanels[paymentMethodType];

  // 8. MAIN JSX
  return (
    <div>
      {ConfigPanel ? (
        <ConfigPanel
          key={paymentMethodType}
          onBack={handleBack}
          paymentTypeName={listPaymentMethodType.find(
            (item) => item.paymentMethodType === paymentMethodType
          )?.paymentTypeName}
        />
      ) : (
        <div className="d-flex flex-wrap gap-2">
          {listPaymentMethodType.map((item) => configPanels[item.paymentMethodType] && (
            <div
              key={item.paymentMethodType}
              className="d-flex align-items-center p-2 border gap-2 pointer"
              style={{ height: 80, borderRadius: 8, minWidth: 200 }}
              onClick={() => setPaymentMethodType(item.paymentMethodType)}
            >
              <img src={item.paymentTypeImageUrl} alt="" width={50} />
              <span>{item.paymentTypeName}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// 9. EXPORTS
export default PaymentMethod;